module.exports = __webpack_public_path__ + "static/media/africanPenguin.5a7cdf4e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/africanPenguin.jpg
// module id = 113
// module chunks = 0